<template>
  <base-detail :title="'Rice'">
    <ul>
      <li class="menuList" v-for="item in rice" :key="item.item">
        <span>{{ item.item }}</span>
        <span> {{ item.singlePrice || "----" }} </span>
        <span>{{ item.halfPrice || "----" }}</span>
        <span>{{ item.fullPrice }}</span>
      </li>
    </ul>
  </base-detail>
</template>

<script>
import data from "./../../../data.json";
export default {
  computed: {
    rice() {
      const dataList = data.filter(
        (row) => row.type === "rice" && row.mealType === "main_course"
      );
      return dataList;
    },
  },
};
</script>
